import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=74b8528e"
import script from "./OrderList.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=74b8528e&prod&lang=stylus"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=74b8528e&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports